import { useState, useEffect } from "react";
import Articles from "../../components/Articles";
import useAxios from "../../Hook/useAxios";
import { useLocation } from "react-router-dom";

function RessourcesRelais() {
	const [allSequences, setAllSequences] = useState([]);
	const [sequencesToShow, setSequencesToShow] = useState(3);
	const [allArticles, setAllArticles] = useState([]);	
	const [activitiesToShow, setActivitiesToShow] = useState(3);
	const [allActivities, setAllActivities] = useState([]);
	const [articlesToShow, setArticlesToShow] = useState(3);
	const data = useAxios("/articles?populate=*");
	const location = useLocation();

	const handleShowMoreSequences = () => {
		setSequencesToShow(prevCount => prevCount + 3);
	};
	const sequencesToDisplay = allSequences.slice(0, sequencesToShow);

	const handleShowMoreActivities = () => {
		setActivitiesToShow(prevCount => prevCount + 3);
	};
	const activitiesToDisplay = allActivities.slice(0, activitiesToShow);

	const handleShowMoreArticles = () => {
		setArticlesToShow(prevCount => prevCount + 3);
	};
	const articlesToDisplay = allArticles.slice(0, articlesToShow);

	useEffect(() => {
		// set page title
		const metaDescriptionTag = document.querySelector('meta[name="description"]');
		document.title = 'Ressources - Parlons Règles';
		if (metaDescriptionTag) {
			metaDescriptionTag.setAttribute('content', "Ces ressources vont vous permettre d'aborder le sujet des règles en classe et de construire des séquences pédagogiques sur les menstruations.");
		}

		const getDataArticles = () => {
			if (data) {
				const articles = data.data.data.map((item) => ({
					id: item.id,
					push_first: item.attributes.push_first,
					content: item.attributes.content,
					createdAt: item.attributes.createdAt,
					publishedAt: item.attributes.publishedAt,
					title: item.attributes.title,
					header: item.attributes.header_image.data.attributes.url,
					category: item.attributes.categories.data.map(
						(category) => ({
							name: category.attributes.name,
							visible: category.attributes.visible,
						})
					),
				}));

				// on renvoie uniquement les articles qui ont le tag "Séquence pédagogique"
				let filteredSequences = articles.filter(article => {
					return article.category.some(cat => {
						return cat.name === "Séquence pédagogique";
					});
				  });
				const sortedSequences = filteredSequences.sort(
					(a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
				);
				setAllSequences(sortedSequences);

				// on renvoie uniquement les articles qui ont le tag "Activité"
				let filteredActivities = articles.filter(article => {
					return article.category.some(cat => {
						return cat.name === "Activité";
					});
				  });
				const sortedActivities = filteredActivities.sort(
					(a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
				);
				setAllActivities(sortedActivities);

				// on renvoie uniquement les articles qui ont le tag "Article"
				let filteredArticles = articles.filter(article => {
					return article.category.some(cat => {
						return cat.name === "Article";
					});
				  });
				const sortedArticles = filteredArticles.sort(
					(a, b) => new Date(b.publishedAt) - new Date(a.publishedAt)
				);
				setAllArticles(sortedArticles);
			}
		};
		getDataArticles();
	}, [data, location.state]);

	const allRessources = allSequences.concat(allActivities).concat(allArticles);
	const articlesFirst = allRessources.filter(
		(article) => article.push_first === true
	);

	return (
		<div className="allRessources">
			<div className="allRessources__articles">
				<div className="allRessources__une-container">
					<h1 className="allRessources__first">
						À la{" "}
						<b>
							<i>une</i>
						</b>
					</h1>
					<Articles ListArticles={articlesFirst} />
				</div>
				
				<h1 id="sequences" className="allRessources__last">
					Les séquences{" "}
					<strong>
						<i>pédagogiques</i>
					</strong>
				</h1>
				<Articles ListArticles={sequencesToDisplay} />
				{sequencesToShow < allSequences.length && (
					<button className='allRessources__show-more-button' onClick={handleShowMoreSequences}>
						Voir plus de séquences
					</button>
				)}

				<h1 id="activities" className="allRessources__last">
					Les{" "}
					<strong>
						<i>activités</i>
					</strong>
				</h1>
				<Articles ListArticles={activitiesToDisplay} />
				{activitiesToShow < allActivities.length && (
					<button className='allRessources__show-more-button' onClick={handleShowMoreActivities}>
						Voir plus d'activités
					</button>
				)}

				<h1 id="articles" className="allRessources__last">
					Les{" "}
					<strong>
						<i>articles</i>
					</strong>
				</h1>
				<Articles ListArticles={articlesToDisplay} />
				{articlesToShow < allArticles.length && (
					<button className='allRessources__show-more-button' onClick={handleShowMoreArticles}>
						Voir plus d'articles
					</button>
				)}
			</div>
		</div>
	);
}

export default RessourcesRelais;